import React from 'react';

/**
 * Formats digits into +998 XX XXX XX XX
 * Accepts: 998901234567 / 901234567 / +998 90 123 45 67
 */
function formatUzPhone(raw) {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 0) return '';

  // Strip leading country code
  const d = digits.startsWith('998')
    ? digits.slice(3)
    : digits.startsWith('0')
    ? digits.slice(1)
    : digits;

  // Build formatted string progressively as user types
  let result = '+998';
  if (d.length === 0) return result;
  result += ' ' + d.slice(0, 2);
  if (d.length <= 2) return result;
  result += ' ' + d.slice(2, 5);
  if (d.length <= 5) return result;
  result += ' ' + d.slice(5, 7);
  if (d.length <= 7) return result;
  result += ' ' + d.slice(7, 9);
  return result;
}

export default function PhoneInput({ value, onChange, placeholder, style }) {
  const handleChange = (e) => {
    const raw = e.target.value;

    // Allow clearing
    if (!raw || raw === '+') {
      onChange('');
      return;
    }

    // Don't format if user is deleting (let them clear spaces freely)
    if (value && raw.length < value.length) {
      // Strip non-digits and reformat
      onChange(formatUzPhone(raw));
      return;
    }

    onChange(formatUzPhone(raw));
  };

  return (
    <input
      type="tel"
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder || '+998 90 123 45 67'}
      style={style}
      maxLength={17}  // +998 XX XXX XX XX = 17 chars
    />
  );
}

export { formatUzPhone };
